import { createContext, use } from 'react';

import { useAgentVoiceQuery } from '@/query/agent.query';

import type { Voice } from '@/types/agent.type';

interface VoiceContextType {
  voices: Voice[];
  loading: boolean;
}

const VoiceContext = createContext<VoiceContextType | undefined>(undefined);

export function VoiceProvider({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useAgentVoiceQuery();
  const voices = data || [];

  return <VoiceContext value={{ voices, loading: isLoading }}>{children}</VoiceContext>;
}

export function useVoices() {
  const context = use(VoiceContext);
  if (!context) throw new Error('useVoices must be used within VoiceProvider');
  return context;
}
